/**
 * Month / year / week-start used by the Calendars gallery.
 * The month always defaults to the current month when the app loads (session-only override); the week-start
 * preference is remembered per browser.
 */
import { defaultCalendar } from './buildingBlocks';

const KEY = 'wp.calendarWeekStart';
let session = null;

export const getCalendarPrefs = () => {
  if (session) return session;
  let weekStart = 0;
  try { const v = Number(window.localStorage.getItem(KEY)); if (v === 1) weekStart = 1; } catch { /* ignore */ }
  session = { ...defaultCalendar(), weekStart };
  return session;
};

export const setCalendarPrefs = (next) => {
  session = { ...getCalendarPrefs(), ...next };
  try { window.localStorage.setItem(KEY, String(session.weekStart)); } catch { /* ignore */ }
  return session;
};
